import { Theme } from '@material-ui/core';

export function theme(props: any) {
  return props.theme as Theme;
}